import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue'
import { FilhoMacon } from '@/../common/types/FilhoMacon'
import { paramaconicos } from '@/shareds/sharedsIrmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'TableFilhos',
  props: {
	filhos: {
		type: Array as PropType<FilhoMacon[]>,
		default: () => [],
	},
},
  setup(__props) {

const props = __props;



const headers = [
	{
		text: 'Nome',
		align: 'left',
		value: 'nome',
		class: 'text-truncate',
	},
	{ text: 'Paramaçônico', value: 'paramaconico' },
	{ text: 'Ações', value: 'action', sortable: false, width: 80 },
]
const dialog = ref(false)
const editedIndex = ref(-1)
const filhoEditado = ref<FilhoMacon>({
	nome: '',
	paramaconico: undefined,
})
const filhoDefault: FilhoMacon = {
	nome: '',
	paramaconico: undefined,
}

const formTitle = computed(() => editedIndex.value === -1 ? 'Novo Filho' : 'Editar Filho')

function editItem(item: FilhoMacon) {
	editedIndex.value = props.filhos.indexOf(item)
	filhoEditado.value = Object.assign({}, item)
	dialog.value = true
}

function deleteItem(item: FilhoMacon) {
	const index = props.filhos.indexOf(item)
	if (!window.confirm(`Deseja mesmo remover ${item.nome}?`)) return
	props.filhos.splice(index, 1)
}

function close() {
	dialog.value = false
	setTimeout(() => {
		filhoEditado.value = Object.assign({}, filhoDefault)
		editedIndex.value = -1
	}, 300)
}

function save() {
	if (editedIndex.value > -1) {
		Object.assign(props.filhos[editedIndex.value], filhoEditado.value)
	} else {
		props.filhos.push(filhoEditado.value)
	}
	close()
}

return { __sfc: true,props, headers, dialog, editedIndex, filhoEditado, filhoDefault, formTitle, editItem, deleteItem, close, save, paramaconicos }
}

})